const products = [
  {
    Name: "28mm short pet lock cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "28 mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Quantity Per Pack": "10000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco tst",
    },
    Description:
      "Experience top-tier sealing with our 28mm plastic TST cap, trusted by pharmaceutical, pesticide, oil, and ayurvedic industries. Engineered to ensure secure closure and preservation of your valuable products.",
    image: "/DSC_1965.webp",
  },

  {
    Name: "20 Ltr jar cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "20Ltr Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "20 LTRl bottles",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Introducing our 20-liter plastic ROPP cap, designed specifically for 2-liter handle bottles. Featuring a one-piece slitted design with its own seal and an internal wad to prevent leakage, this cap is crafted using highly proven injection molding technology for reliable performance.",
    image: "/DSC_1984.webp",
  },
  {
    Name: "2 Ltr handle",
    category: "cap",
    Specifications: {
      Type: "2ltr handle",
      "Plastic Material": "HDPE",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      Finishing: "2ltr handle",
      "Quantity Per Pack": "4000",
      Weight: "2",
      Usage: "2ltr bottles",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "4000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Discover the versatility of our 2Ltr plastic ROPP handle, a trusted choice in pharmaceuticals, pesticides, oils, and ayurvedic industries. Crafted with precision using advanced injection molding technology, it ensures reliability and ease of use in various applications.",
    image: "/DSC_2004.webp",
  },

  {
    Name: "25mm pet lock cap with wad",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "25 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco  ropp",
    },
    Description:
      "Introducing our 25mm plastic ROPP cap, tailored for pharmaceuticals, pesticides, oils, and ayurvedic products. This one-piece slitted cap features its own seal and an internal wad, ensuring leak-free performance, all crafted with advanced injection molding technology.",
    image: "/DSC_2208.webp",
  },
  {
    Name: "28mm pet lock cap with wad",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "28 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical  pesticied ayurvedic   oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco  ropp",
    },
    Description:
      "Introducing our 28mm plastic ROPP cap, the preferred choice for pharmaceuticals, pesticides, oils, and ayurvedic products. This one-piece slitted cap features its own seal and an internal wad, ensuring leak-free performance, all crafted with highly proven injection molding technology.",
    image: "/DSC_2249.webp",
  },

  {
    Name: "25mm & 28mm Umbrella Cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "25 & 28 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "25 28",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Introducing our 25 & 28mm plastic ROPP cap, tailored for pharmaceuticals, pesticides, oils, and ayurvedic products. This one-piece slitted cap features its own seal and a built-in wad to prevent leakage, all made possible through advanced injection molding technology.",
    image: "/DSC_2199.webp",
  },
  {
    Name: "42mm flip Spice Cap",
    category: "cap",
    Specifications: {
      Type: "flip top cap",
      "Plastic Material": "PP",
      "Packaging Type": "bag",
      "Neck Finishing": "42mm",
      "Quantity Per Pack": "2500",
      Weight: "6",
      Usage: "sprinkler for spice and herbs etc",
      "MinimumOrder Quantity": "2500",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description: "42mm spice sprinkler cap sutable for pet and glass jar ",
    image: "/DSC_2123.webp,/DSC_2284.webp",
  },
  {
    Name: "28mm flip top cap kettle with ring ",
    category: "cap",
    Specifications: {
      Type: "One piece cap with & without ring",
      Size: "28mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Neck Type": "pco   ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic   oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 28mm plastic ROPP cap, trusted across pharmaceuticals, pesticides, oils, and ayurvedic sectors. Crafted with a one-piece slitted design and an internal wad, this cap ensures leakage-free performance, leveraging advanced injection molding technology for proven reliability.",
    image: "/DSC_2151.webp",
  },
  {
    Name: "28mm flip top cap with ring ",
    category: "cap",
    Specifications: {
      Type: "One piece cap with & without ring",
      Size: "28mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Neck Type": "pco  ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic  oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 28mm flip cap plastic ROPP cap, ideal for pharmaceuticals, pesticides, oils, and ayurvedic industries. Crafted as a seamless one-piece design without the need for an additional seal, this cap is manufactured using trusted injection molding technology, ensuring reliability and ease of use.",
    image: "/DSC_2192.webp",
  },
  {
    Name: "28mm flip top cap without ring ",
    category: "cap",
    Specifications: {
      Type: "One piece cap with & without ring",
      Size: "28mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Neck Type": "pco ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical Pesticied Ayurvedic  oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 28mm flip cap plastic ROPP cap, ideal for pharmaceuticals, pesticides, oils, and ayurvedic industries. Crafted as a seamless one-piece design without the need for an additional seal, this cap is manufactured using trusted injection molding technology, ensuring reliability and ease of use.",
    image: "/DSC_2195.webp",
  },
  {
    Name: "25mm flip top cap with & without ring",
    category: "cap",
    Specifications: {
      Type: "One piece cap with & without ring",
      Size: "25mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Neck Type": "pco ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 25mm flip cap plastic ROPP cap, essential for pharmaceuticals, pesticides, oils, and ayurvedic products. Crafted with advanced injection molding technology, this one-piece cap ensures secure closure without the need for a separate seal, guaranteeing reliability and convenience.",
    image: "/DSC_2184.webp",
  },

  {
    Name: "20mm flip top cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap with & without ring",
      Size: "20mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "20",
      "Neck Type": "pco ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 20mm flip cap plastic ROPP cap, essential for pharmaceuticals, pesticides, oils, and ayurvedic products. Crafted with advanced injection molding technology, this one-piece cap ensures secure closure without the need for a separate seal, guaranteeing reliability and convenience.",
    image: "/DSC_2431.png,/DSC_2432.png,/DSC_2434.png",
  },

  {
    Name: "25mm special flip top cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap without ring",
      Size: "25mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Neck Type": "pco ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 25mm special flip cap plastic ROPP cap, essential for pharmaceuticals, pesticides, oils, and ayurvedic products. Crafted with advanced injection molding technology, this one-piece cap ensures secure closure without the need for a separate seal, guaranteeing reliability and convenience.",
    image: "/DSC_2126.webp",
  },

  {
    Name: "25mm T flip top cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap without ring",
      Size: "25mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Neck Type": "pco ropp",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 25mm T flip cap plastic ROPP cap, essential for pharmaceuticals, pesticides, oils, and ayurvedic products. Crafted with advanced injection molding technology, this one-piece cap ensures secure closure without the need for a separate seal, guaranteeing reliability and convenience.",
    image: "/DSC_2435.png",
  },

  {
    Name: "20 mm flip snap fitte",
    category: "cap",
    Specifications: {
      Type: "One piece cap with ring",
      Size: "20 mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round flip",
      "Packaging Type": "bag",
      "Neck Finishing": "20",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical Pesticied Ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 20mm flip snap fitte, designed to meet the versatile needs of various industries. This innovative product features a convenient flip design for easy access and secure closure, ensuring the safety and integrity of your contents. Crafted with precision and durability in mind, our flip snap fitte is the perfect solution for your packaging needs.",
    image: "/DSC_2428.webp",
  },
  {
    Name: "25mm pet lock cap with ring",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "25 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Introducing our 25mm plastic ROPP cap, ideal for pharmaceuticals, pesticides, oils, and ayurvedic products. With a one-piece slitted design featuring its own seal and an internal plug, this cap ensures leak-free performance, crafted using highly proven injection molding technology.",
    image: "/DSC_2215.webp",
  },

  {
    Name: "300ml Milk Glass Bottle Cap",
    category: "cap",
    Specifications: {
      Size: "42mm",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Quantity Per Pack": "2500",
      Usage: "Mineral Water, Edible Oil, Juice, Milk, Chemicals etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "1 Bag",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "Black",
      "Neck Type": "tst",
    },
    Description:
      "Proud to preseent our 300ml milk glass bottle cap, designed to meet the needs of the dairy industry. Crafted with precision and durability in mind, this cap ensures a secure seal for your milk bottles, preserving freshness and quality. Made from high-quality materials, our milk glass bottle cap is the perfect choice for dairy producers looking for reliable packaging solutions.",
    image: "/DSC_2436.webp",
  },

  {
    Name: "25mm without lock cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap without seal",
      Size: "25 mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Neck Finishing": "25",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical Pesticied Ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Our 25 mm plastic ROPP cap is mainly used in pharma companies, pesticides companies, oil companies, ayurvedic companies. It is a 1 piece  cap which is having its not seal. Its a highly proved injection  moulding technology cap.",
    image: "/DSC_2202.webp",
  },
  {
    Name: "28mm pet lock pco cap with ring ",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "28 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical pesticied  ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco  ropp",
    },
    Description:
      "Introducing our 28mm plastic ROPP cap, trusted across pharmaceuticals, pesticides, oils, and ayurvedic sectors. Crafted with a one-piece slitted design and an internal wad, this cap ensures leakage-free performance, leveraging advanced injection molding technology for proven reliability.",
    image: "/DSC_2218.webp",
  },
  {
    Name: "28mm without lock cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap without seal",
      Size: "28mm Neck Size",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Neck Finishing": "28",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical  pesticied ayurvedic  oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Introducing our versatile 28mm plastic ROPP cap, a staple in pharmaceuticals, pesticides, oils, and ayurvedic industries. Crafted as a seamless one-piece design without the need for an additional seal, this cap is manufactured using trusted injection molding technology, ensuring reliability and efficiency.",
    image: "/DSC_2206.webp",
  },
  {
    Name: "Sauce cap",
    category: "cap",
    Specifications: {
      Type: "One piece cap with seal",
      Size: "29 mm Neck Size",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Seal Type": "Slitted",
      "Packaging Type": "bag",
      "Neck Finishing": "29",
      "Quantity Per Pack": "5000",
      Weight: "2",
      Usage: "Pharmaceutical Pesticied Ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
      "Neck Type": "pco ropp",
    },
    Description:
      "Introducing our 29mm plastic ROPP cap, essential for pharmaceuticals, pesticides, oils, and ayurvedic industries. This one-piece slitted cap features its own seal and an internal wad, ensuring leak-free performance, all crafted with highly proven injection molding technology.",
    image: "/DSC_2272.webp",
  },

  {
    Name: "Beer cap ",
    category: "cap",
    Specifications: {
      Type: "Beer cap",
      "Plastic Material": "LDPE",
      Shape: "Round",
      "Packaging Type": "bag",
      "Quantity Per Pack": "25pkt",
      Weight: "2",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      Industrial: "Use all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "natural",
    },
    Description:
      "Our Plastic Beer Cap provides the ultimate safety of the products and is available at the best wholesale rates.",
    image: "/DSC_2340.webp",
  },
  {
    Name: "Pet inner",
    category: "cap",
    Specifications: {
      Type: "pet inner",
      Size: "5,7,9,10 (25 mm neck) & 11 (28 mm neck)",
      "Plastic Material": "HDPE",
      Shape: "Round",
      "Packaging Type": "bag",
      "Quantity Per Pack": "25pkt",
      Usage: "Pharmaceutical Pesticied Ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "25000nos",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "natural",
    },
    Description:
      "Upgrade your packaging with our versatile plastic inner components, available in sizes 5, 7, 9, 10, and 11. Ideal for pharmaceuticals, pesticides, oils, and ayurvedic products, they're crafted using advanced injection molding for durability and precision.",
    image: "/DSC_2352.webp",
  },
  {
    Name: "10ml measuring cup",
    category: "measuring cup",
    Specifications: {
      Type: "Measuring cup",
      Size: "10ml measuring cup",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Quantity Per Pack": "5000nos",
      Weight: "2",
      Usage: "Pharmaceutical ayurvedic Syrups Medicines Industrial Use",
      Recyclable: "Yes",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "Transparent Measuring cup",
    },
    Description:
      "Leading manufacturer, supplier and exporter of\u00a0 10ml PP Plastic Measuring Cups\u00a0which is widely used in pharma industries.",
    image: "/DSC_2339.webp",
  },
  {
    Name: "25ml & 60ml puring glass ",
    category: "Measuring Cup",
    Specifications: {
      Type: "puring glass",
      Size: "25ml & 60ml",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Neck Finishing": "25ml & 60ml",
      "Quantity Per Pack": "1800nos",
      Weight: "3.95 & 6.85",
      Usage: "Pharmaceutical pesticied ayurvedic oil bottles etc",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "1800",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "natural",
    },
    Description:
      "Introducing our premium 25ml and 60ml pouring glass, meticulously crafted to meet the rigorous demands of pharmaceutical, pesticide, and ayurvedic industries. Engineered with cutting-edge injection molding technology, our pouring glass sets the standard for precision and reliability.",
    image: "/DSC_2334.webp",
  },
  {
    Name: "15gm lock jar",
    category: "Lock Jar",
    Specifications: {
      Brand: "vp",
      Size: "15gm",
      Shape: "Round",
      Color: " white ",
      "Usage/Application": "Utility Pharmaceutical, pesticied, ayurvedic ",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "15gm",
      "Minimum Order": "5000 Piece",
    },
    Description:
      "Discover our range of food-grade plastic lock jars, engineered for heavy-duty use and spill-proof storage. Experience quality at an affordable price with our reliable containers.",
    image: "/DSC_2236.webp",
  },
  {
    Name: "50gm lock jar",
    category: "Lock Jar",
    Specifications: {
      Brand: "vp",
      Size: " 50gm",
      Shape: "Round",
      Color: " white ",
      "Usage/Application": "Utility Pharmaceutical, pesticied, ayurvedic ",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "50gm",
      "Minimum Order": "3000 Piece",
    },
    Description:
      "Discover our range of food-grade plastic lock jars, engineered for heavy-duty use and spill-proof storage. Experience quality at an affordable price with our reliable containers.",
    image: "/DSC_2230.webp,/DSC_2235.webp",
  },
  {
    Name: "100gm lock jar ",
    category: "Lock Jar",
    Specifications: {
      Brand: "vp",
      Size: "100gm ",
      Shape: "Round",
      Color: " white ",
      "Usage/Application": "Utility Pharmaceutical, pesticied, ayurvedic ",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: ", 100gm ",
      "Minimum Order": "1500 Piece",
    },
    Description:
      "Discover our range of food-grade plastic lock jars, engineered for heavy-duty use and spill-proof storage. Experience quality at an affordable price with our reliable containers.",
    image: "/DSC_2228.webp",
  },
  {
    Name: "Kayam Jar Cap",
    category: "Jar Cap",
    Specifications: {
      Brand: "vp",
      Size: "10 ml",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Homeopathic",
      Material: "pp",
    },
    Description:
      "We provide our customers with 10ml Kayam jar cap of the highest quality at reasonable rates.",
    image: "/DSC_2124.webp",
  },
  {
    Name: "food container 100ml",
    category: "Container",
    Specifications: {
      Brand: "vp",
      Size: "100ml",
      Shape: "Round",
      Color: "transparent, black & white ",
      "Usage/Application": "Utility Dishes",
      Use: "Event and Party Supplies, Utility Dishes",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "100 ml",
      "Minimum Order Quantity": "2000 Piece",
    },
    Description:
      "We are deal in Plastic container food grade heavy duty and spill proof. used for food delivery at affordable price.",
    image: "/DSC_2074.webp,/DSC_2106.webp",
  },
  {
    Name: "food container 250ml",
    category: "Container",
    Specifications: {
      "Minimum Order Quantity": "1000 Piece",
      Brand: "vp",
      Size: "250ml",
      Shape: "Round",
      Color: "transparent, black & white ",
      "Usage/Application": "Utility Dishes",
      Use: "Event and Party Supplies, Utility Dishes",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "250ml",
    },
    Description:
      "We are deal in Plastic container food grade heavy duty and spill proof. used for food delivery at affordable price.",
    image: "/DSC_2117.webp",
  },
  {
    Name: "food container 500ml",
    category: "Container",
    Specifications: {
      "Minimum Order Quantity": "1000 Piece",
      Brand: "vp",
      Size: "500ml",
      Shape: "Round",
      Color: "transparent, black & white ",
      "Usage/Application": "Utility Dishes",
      Use: "Event and Party Supplies, Utility Dishes",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "500ml",
    },
    Description:
      "We are deal in Plastic container food grade heavy duty and spill proof. used for food delivery at affordable price.",
    image: "/DSC_2095.webp,/DSC_2029.webp",
  },
  {
    Name: "food container 750ml",
    category: "Container",
    Specifications: {
      "Minimum Order Quantity": "600 Piece",
      Brand: "vp",
      Size: "750ml",
      Shape: "Round",
      Color: "transparent, black & white ",
      "Usage/Application": "Utility Dishes",
      Use: "Event and Party Supplies, Utility Dishes",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "750ml",
    },
    Description:
      "We are deal in Plastic container food grade heavy duty and spill proof. used for food delivery at affordable price.",
    image: "/DSC_2103.webp,/DSC_2046.webp,/DSC_2068.webp",
  },
  {
    Name: "food container 1000ml",
    category: "Container",
    Specifications: {
      "Minimum Order Quantity": "700 Piece",
      Brand: "vp",
      Size: "1000ml",
      Shape: "Round",
      Color: "transparent, black & white ",
      "Usage/Application": "Utility Dishes",
      Use: "Event and Party Supplies, Utility Dishes",
      Disposable: "Yes",
      Material: "Plastic",
      Capacity: "1000ml",
    },
    Description:
      "We are deal in Plastic container food grade heavy duty and spill proof. used for food delivery at affordable price.",
    image: "/DSC_2094.webp",
  },
  {
    Name: "Pet Jar Cap",
    category: "Jar Cap",
    Specifications: {
      Brand: "vp",
      Size: "38-120 mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Jar",
      Material: "pp",
    },
    Description:
      "We provide our customers with PET jar caps of the highest quality.",
    image:
      "/DSC_2381.webp,/DSC_2361.webp,/DSC_2045.jpg,/DSC_2367.webp,/DSC_2044.jpg",
  },
  {
    Name: "Pet Jar Cap with handle",
    category: "Jar Cap",
    Specifications: {
      Brand: "vp",
      Size: "83-120 mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Jar",
      Material: "pp",
    },
    Description:
      "We provide our customers with PET jar cap with handle of the highest quality.",
    image: "/DSC_2299.webp",
  },
  {
    Name: "Dom Jar Caps",
    category: "Jar Cap",
    Specifications: {
      Brand: "vp",
      Size: "38-83 mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Jar",
      Material: "pp",
    },
    Description:
      "We provide our customers with Dom jar cap of the highest quality.",
    image: "/DSC_2394.webp",
  },

  {
    Name: "83MM Jar Cap",
    category: "Jar Cap",
    Specifications: {
      Brand: "vp",
      Size: "83 mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Homeopathic",
      Material: "pp",
    },
    Description:
      "We provide our customers with 83mm Jar Cap of the highest quality at reasonable rates.",
    image: "/DSC_2430.webp",
  },

  {
    Name: "Balm Jar",
    category: "Lock Jar",
    Specifications: {
      Brand: "vp",
      Size: "10mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Homeopathic & Cosmetic",
      Material: "pp",
    },
    Description:
      "We provide our customers with 10mm balm jar of the highest quality at reasonable rates.",
    image: "/DSC_2125.webp",
  },
  {
    Name: "Sample Collection Jar",
    category: "Lock Jar",
    Specifications: {
      Brand: "vp",
      Size: "40ml",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application": "Medical",
      Material: "pp",
    },
    Description:
      "We provide our customers with 40 ml Sample collection jar of the highest quality at reasonable rates.",
    image: "/DSC_2127.jpg",
    Quantity: "100 ps/pkt",
  },
  {
    Name: "38 mm Pet Lock Cap with Plug",
    category: "Cap",
    Specifications: {
      Brand: "vp",
      Size: "38mm",
      Shape: "Round",
      Color: "all colours ",
      "Usage/Application":
        "Mineral Water , edible oil , juice, milk, chemicals",
      Material: "hdpe",
    },
    Description:
      "Introducing our 38mm PET Lock Cap—designed with precision and reliability. This secure cap features an integrated plug to prevent leakage, ensuring optimal protection for your liquids.",
    image: "/DSC_2129.jpg",
    Quantity: "5000 ps/bag",
  },
  {
    Name: "15ml measuring spoon",
    category: "measuring cup",
    Specifications: {
      Type: "Measuring Spoon",
      Size: "15ml",
      "Plastic Material": "PP",
      Shape: "Spoon",
      "Packaging Type": "bag",
      "Quantity Per Pack": "5000nos",
      Usage: "Pharmaceutical ayurvedic Syrups Medicines Industrial Use",
      Recyclable: "Yes",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "Transparent",
    },
    Description:
      "Leading manufacturer, supplier and exporter of\u00a0 10ml, 15ml PP Plastic Measuring Spoons\u00a0which is widely used in pharma industries.",
    image: "/DSC_2142.jpg",
  },
  {
    Name: "15ml measuring cup",
    category: "measuring cup",
    Specifications: {
      Type: "Measuring cup",
      Size: "15ml measuring cup",
      "Plastic Material": "PP",
      Shape: "Round",
      "Packaging Type": "bag",
      "Quantity Per Pack": "5000nos",
      Weight: "2",
      Usage: "Pharmaceutical ayurvedic Syrups Medicines Industrial Use",
      Recyclable: "Yes",
      "Minimum Order Quantity": "5000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "Transparent Measuring cup",
    },
    Description:
      "Leading manufacturer, supplier and exporter of\u00a0 10ml, 15ml PP Plastic Measuring Cups\u00a0which is widely used in pharma industries.",
    image: "/DSC_2132.jpg",
  },
  {
    Name: "48mm Single Handle",
    category: "cap",
    Specifications: {
      Quantity: "1000 per bag",
      Usage: "Packaged drinking water and edible oil",
      "Industrial Use": "all",
      "Is It Recyclable": "Recyclable",
      "Minimum Order Quantity": "4000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Single Handle Design High-Strength Handle for 5-Litre Containers Crafted for enhanced durability, this single-handle design provides superior strength for 5-litre containers, ensuring easy handling and a secure grip in demanding applications.",
    image: "/DSC_2133.jpg",
  },
  {
    Name: "46mm Butterfly Handle",
    category: "cap",
    Specifications: {
      Size: "46mm",
      Quantity: "2000 per bag",
      Usage: "Oil , Strong Aroma , Chemicals, Mineral Water",
      "Industrial Use": "all",
      "Minimum Order Quantity": "4000",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "All colour",
    },
    Description:
      "Introducing our 46mm Butterfly Handle with precision and reliability.",
    image: "/DSC_2136.jpg",
  },
  {
    Name: "46 mm pet lock cap",
    category: "cap",
    Specifications: {
      Size: "46mm",
      Shape: "Round",
      Packaging: "3000 pcs/bag",
      Usage: " Edible Oil , Strong Aroma , Chemicals, Packaged Drinking Water",
      "Industrial Use": "all",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "white, yellow",
      "Neck Type": "tst",
    },
    Description:
      "High-Strength 5-Litre Cap Designed for durability, this 46mm PET lock cap ensures a secure seal for 5-litre containers, offering enhanced strength and reliability. Ideal for safeguarding liquids with a tight, leak-proof closure.",
    image: "/DSC_2137.jpg",
  },
  {
    Name: "48 mm pet lock cap",
    category: "cap",
    Specifications: {
      Size: "48mm",
      Shape: "Round",
      Packaging: "2000 pcs/bag",
      Usage: " Packaged drinking water and edible oil",
      "Industrial Use": "all",
      Quality: "100% Virgin Raw Material",
      "Available Colours": "white, yellow",
      "Neck Type": "tst",
    },
    Description:
      "H120-Knurling Round Flap Cap – High-Strength Seal Engineered for durability, this high-strength cap features 120 knurling for enhanced grip and a round flap design for a secure, leak-proof seal. Ideal for reliable closure in various applications.",
    image: "/DSC_2138.jpg",
  },
];

export default products;
